export default __webpack_public_path__ + "static/ay-support-content-eye-5edfec2cb20499f530872cb30a131f19.svg";